<!--修改密码-->
<template>
  <div class="com-table password border">
    <div class="com-title pr">修改密码</div>
    <el-form label-width="100px" :model="formAlign" ref="formAligns" @keyup.enter.native="submitForm('formAligns')">
      <el-form-item label="原密码：" prop="oldPassword" :rules="{ required: true, message: '输入原密码', trigger: 'change' }">
        <el-input placeholder="输入原密码" v-model="formAlign.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="password" :rules="{ required: true, message: '输入新密码', trigger: 'change' }">
        <el-input placeholder="输入新密码" v-model="formAlign.password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirm" :rules="{ required: true, message: '请再次输入新密码', trigger: 'change' }">
        <el-input placeholder="请再次输入新密码" v-model="formAlign.confirm"></el-input>
      </el-form-item>
      <div class="button">
        <el-button type="primary" size="small" @click="submitForm('formAligns')">保存</el-button>
        <el-button type="reset" size="small" @click="resetForm('formAligns')">重置</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import Api from '@/api/password'
  import {FormArgument} from '@/models/password'
  export default {
    data () {
      return {
        formAlign: new FormArgument()
      }
    },
    methods: {
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            Api.modify({'form': this.formAlign}, response => {
              let status = response.data.code
              let info = response.data.msg
              if (status === '200') {
                this.$message.success('修改成功,请刷新后重新登录！')
                // this.$refs['formAligns'].resetFields()
                this.$store.dispatch('logout')
                this.$cookie.delete('_qd_emcp.l_s')
                this.$router.push('/login')
              } else {
                this.$message.error(info)
              }
            })
          } else {
            return false
          }
        })
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

  .password {
    .button {
      padding: 33px 0;
      text-align: center;
    }
  }
</style>
<style lang="scss">
  .password {
    .el-button {
      background: #085ECC;
      padding: 9px 35px;
      outline: none;
      border:1px solid #085ECC;
    }
    .el-button--reset{
      box-sizing: border-box;
      background:white;
      color:#085ECC;
    }
    .el-input__inner {
      width: 200px;
      height: 32px;
      line-height: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/ChangePassword.vue